import * as React from "react";
const SvgFiRrHeadSideThinking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-head-side-thinking_svg__a)">
      <path
        fill="#062147"
        d="M19.8 4.419A10.9 10.9 0 0 0 9.453.106 11 11 0 0 0 2.26 17.674c.496.684.756 1.51.74 2.355v.97a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3h.494a5.014 5.014 0 0 0 4.957-4.344L21.67 15H22a1.96 1.96 0 0 0 2-2c0-1.42-2.932-7.015-4.2-8.581m.993 8.58a1 1 0 0 0-.991.87l-.334 2.525A3.01 3.01 0 0 1 16.494 19H15a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-.971a5.9 5.9 0 0 0-1.151-3.571 9 9 0 0 1 5.876-14.37A9 9 0 0 1 11.005 2a8.94 8.94 0 0 1 7.218 3.648A31.2 31.2 0 0 1 22 13zM16.2 8.012a1 1 0 0 0-1.366-.37l-.982.565A4 4 0 0 0 12 7.142V6a1 1 0 0 0-2 0v1.142a4 4 0 0 0-1.855 1.064l-.982-.564a1 1 0 0 0-1 1.734l.993.57Q7.006 10.463 7 11c.005.356.058.71.159 1.053l-.993.57a1 1 0 1 0 1 1.735l.982-.564c.509.516 1.15.884 1.852 1.064V16a1 1 0 0 0 2 0v-1.142a4 4 0 0 0 1.855-1.064l.982.564a1.002 1.002 0 0 0 1-1.734l-.993-.571c.1-.343.152-.697.156-1.053a4 4 0 0 0-.16-1.053l.994-.571A1 1 0 0 0 16.2 8.01M11 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-head-side-thinking_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHeadSideThinking;
